// extracted by mini-css-extract-plugin
export default {"tourBanner":"TourDetailsBanner_tourBanner__9XELY","heading-tertirary":"TourDetailsBanner_heading-tertirary__FDQgM"};